import * as Yup from 'yup';

export const RecordSchema = Yup.object()
                               .shape({
                                          accountNumber: Yup.string()
                                                             .required('Required'),
                                          accountHolderName: Yup.string()
                                                                  .required('Required'),
                                          accountHolderType: Yup.string()
                                                                  .required('Required'),
                                          country: Yup.string()
                                                      .required('Required'),
                                          currency: Yup.string()
                                                       .required('Required'),
                                      });
